import { render, staticRenderFns } from "./StoreForm.vue?vue&type=template&id=e5580628"
import script from "./StoreForm.vue?vue&type=script&lang=js"
export * from "./StoreForm.vue?vue&type=script&lang=js"
import style0 from "./StoreForm.vue?vue&type=style&index=0&id=e5580628&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports